var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconPaddleboard = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c19rtz650a",
    d: "M0 .216h.887v.449H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ffi7qey2cc",
    d: "M0 .217h.887v.446H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tpof2s7cqe",
    d: "M0 .217h.887v.446H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3dly333sxg",
    d: "M0 .21h.887v.46H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9o2u052xbi",
    d: "M0 .21h.887v.46H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r0omm6ayuk",
    d: "M.219 0h.45v.88h-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af7y0bydem",
    d: "M0 .196h.887v.488H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yra27s12vo",
    d: "M0 .203h.887v.474H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1igemtj1jq",
    d: "M0 .196h.887v.488H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "58j74ty9hs",
    d: "M0 .203h.887v.474H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z4q2zfnyfu",
    d: "M0 .19h.887V.69H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qhmytcm69w",
    d: "M0 .19h.887V.69H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "30368yzp0y",
    d: "M0 .162h.887v.557H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iez0eh22rA",
    d: "M0 .176h.887v.529H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "50nl9fercC",
    d: "M0 .176h.887v.529H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k60g4byfwE",
    d: "M0 .182h.887v.516H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "faa4z0ewqG",
    d: "M0 .183h.887v.515H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nx54fah08I",
    d: "M0 .141h.887V.74H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k4sctssgtK",
    d: "M0 .148h.887v.584H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xegvyrkygM",
    d: "M0 .155h.887v.57H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yhwt9vz4xO",
    d: "M0 .162h.887v.557H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vgauhubzuQ",
    d: "M0 .169h.887v.543H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0zmvmp6apS",
    d: "M0 .169h.887v.543H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.84 2.216c.094.018.189.033.283.055.47.111.857.35 1.163.725.227.278.374.593.433.943.1.599-.036 1.147-.408 1.63a2.076 2.076 0 0 1-1.225.765 2.005 2.005 0 0 1-.628.04 2.258 2.258 0 0 1-.635-.163 2 2 0 0 1-.475-.281 2.121 2.121 0 0 1-.523-.614 1.977 1.977 0 0 1-.25-.708 2.102 2.102 0 0 1 .52-1.708 2.111 2.111 0 0 1 1.35-.673c.004 0 .005-.008.007-.011h.264a.14.14 0 0 0 .096 0h.028z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.32 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kvtfwp6z1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c19rtz650a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.492.216C.46.242.427.234.395.216h.097z",
    fill: "#1A202C",
    mask: "url(#kvtfwp6z1b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.33 7.212h-.511c.102-.023.205-.007.308-.01.067 0 .136-.012.204.01",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.424 23.12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rgxwlyiq2d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ffi7qey2cc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.295.652c.099 0 .198-.004.298.01-.1-.005-.2.012-.298-.01",
    fill: "#1A202C",
    mask: "url(#rgxwlyiq2d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.992 23.12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f5wyh6100f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tpof2s7cqe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.296.66C.394.649.493.653.592.653.493.674.394.657.296.66",
    fill: "#1A202C",
    mask: "url(#f5wyh6100f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.711 23.112)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c1u3s3uujh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3dly333sxg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.357.645C.415.645.473.64.53.655.473.65.414.666.357.645",
    fill: "#1A202C",
    mask: "url(#c1u3s3uujh)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.705 23.113)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kbz2g5ofcj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9o2u052xbi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.358.654C.414.64.472.645.53.645.473.666.415.651.358.654",
    fill: "#1A202C",
    mask: "url(#kbz2g5ofcj)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 21.658)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8d3bss9hzl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r0omm6ayuk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.231.365v.15a.23.23 0 0 1 0-.15",
    fill: "#1A202C",
    mask: "url(#8d3bss9hzl)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.96 5.553v-.136a.19.19 0 0 1 0 .136",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.796 23.099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b90en4tnyn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#af7y0bydem"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.372.631C.42.631.469.628.516.64.468.637.419.652.372.63",
    fill: "#1A202C",
    mask: "url(#b90en4tnyn)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.217 23.106)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tik6o1ntkp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yra27s12vo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.372.647C.419.635.468.637.516.638.469.66.42.644.372.647",
    fill: "#1A202C",
    mask: "url(#tik6o1ntkp)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.625 23.099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kafeqv8wwr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1igemtj1jq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.378.64C.42.628.465.63.51.63.467.653.422.638.378.64",
    fill: "#1A202C",
    mask: "url(#kafeqv8wwr)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.206 23.105)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "czi2xysldt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#58j74ty9hs"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.378.638c.044 0 .088-.004.132.01C.465.644.42.658.378.638",
    fill: "#1A202C",
    mask: "url(#czi2xysldt)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.444 23.092)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0dgpt83x5v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z4q2zfnyfu"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.392.624c.034 0 .07-.004.104.01C.46.63.425.644.392.624",
    fill: "#1A202C",
    mask: "url(#0dgpt83x5v)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.97 23.092)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xfkbqzjtgx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qhmytcm69w"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.392.634C.426.62.46.624.496.624.463.644.426.63.392.634",
    fill: "#1A202C",
    mask: "url(#xfkbqzjtgx)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.086 23.064)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6reu2hyv3z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#30368yzp0y"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.4.606C.427.594.457.596.487.596.461.617.428.605.4.607",
    fill: "#1A202C",
    mask: "url(#6reu2hyv3z)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.842 23.078)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cc0h07ghjB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iez0eh22rA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.398.61C.428.61.46.608.49.62.459.618.427.63.399.61",
    fill: "#1A202C",
    mask: "url(#cc0h07ghjB)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.574 23.078)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rffm3pf95D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#50nl9fercC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.4.62C.427.607.457.61.487.61.46.63.428.619.4.62",
    fill: "#1A202C",
    mask: "url(#rffm3pf95D)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.12 23.085)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xlof5c3fxF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k60g4byfwE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.398.617c.03 0 .062-.003.091.01-.03-.003-.062.01-.09-.01",
    fill: "#1A202C",
    mask: "url(#xlof5c3fxF)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.297 23.085)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kg0ra01s8H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#faa4z0ewqG"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.398.627c.03-.013.06-.01.091-.01-.028.02-.06.007-.09.01",
    fill: "#1A202C",
    mask: "url(#kg0ra01s8H)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.745 23.044)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "se7y75jsrJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nx54fah08I"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.407.585C.43.575.455.575.48.576.458.594.432.584.407.586",
    fill: "#1A202C",
    mask: "url(#se7y75jsrJ)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.536 23.05)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1ksna401mL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k4sctssgtK"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.406.592C.43.582.456.582.481.583.458.601.431.591.406.593",
    fill: "#1A202C",
    mask: "url(#1ksna401mL)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.1 23.057)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pqmec0kukN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xegvyrkygM"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.406.59C.432.59.457.588.481.6.456.599.43.608.406.59",
    fill: "#1A202C",
    mask: "url(#pqmec0kukN)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.336 23.064)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t0lz8v6zsP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yhwt9vz4xO"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.406.597c.025 0 .051-.003.075.009C.456.605.43.615.406.597",
    fill: "#1A202C",
    mask: "url(#t0lz8v6zsP)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.572 23.071)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f7um3ucdtR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vgauhubzuQ"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.406.604C.43.604.458.6.482.614.456.61.43.621.406.603",
    fill: "#1A202C",
    mask: "url(#f7um3ucdtR)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.844 23.071)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cvaq1xn0zT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0zmvmp6apS"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.406.613C.43.6.456.603.481.603.458.623.431.613.406.614",
    fill: "#1A202C",
    mask: "url(#cvaq1xn0zT)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m16.67 15.652-.244 1.382-.268 1.517-.216 1.222a.245.245 0 0 1-.03.09c-.297.48-.581.967-.885 1.443-.028.044-.058.06-.11.06-.68-.003-1.361-.002-2.053-.002.052-.104.099-.2.12-.306a.635.635 0 0 0 .008-.116v-4.086c0-.024-.004-.051.004-.074.063-.178.022-.348-.025-.523-.044-.162-.156-.272-.256-.391-.55-.662-1.101-1.322-1.652-1.981-.026-.03-.032-.056-.02-.092l1.338-4.027a.522.522 0 0 1 .012-.033l.318.27 1.471 1.247c.133.113.3.166.455.24.834.396 1.669.79 2.504 1.183.042.02.048.04.04.084l-.27 1.53-.241 1.363m7.313 6.3a.622.622 0 0 0-.445-.516 1.669 1.669 0 0 0-.52-.072h-5.655c-.041 0-.07-.001-.088-.05-.162-.44-.327-.88-.49-1.32a.119.119 0 0 1-.01-.065l.21-1.201c.09-.517.182-1.035.27-1.552.095-.542.186-1.085.28-1.627l.15-.853.107-.594.13-.755c.014-.09.028-.179.047-.267.002-.011-.005-.05.032-.036.04.016.082.008.122.007a.828.828 0 0 0 .576-.228.806.806 0 0 0 .26-.704.815.815 0 0 0-.27-.524c-.109-.102-.243-.153-.373-.217-.04-.02-.053-.04-.043-.09.039-.194.07-.39.104-.587l.13-.755c.044-.25.09-.502.133-.753.049-.278.094-.556.142-.834.054-.31.11-.618.163-.927l.18-1.02c.003-.02.006-.035.025-.043.059-.024.115-.055.175-.072a.844.844 0 0 0 .635-.88.841.841 0 0 0-.368-.618c-.315-.212-.644-.172-.966-.03-.32.14-.63.306-.945.46-.728.354-1.451.722-2.182 1.074-.101.048-.193.124-.3.157-.483.146-.968.281-1.453.421l-.599.174c.046.043.083.082.125.113.118.091.223.195.336.293.05.045.1.092.152.134.11.09.214.186.322.279.092.08.18.163.273.243.112.096.226.193.335.294.04.035.07.046.12.025.138-.06.277-.119.418-.176.245-.102.497-.188.736-.304.714-.35 1.421-.708 2.131-1.063.026-.013.05-.033.087-.035l-.078.454c-.038.23-.075.46-.115.69l-.12.679c-.04.23-.075.46-.114.69-.044.255-.093.51-.135.765-.043.267-.091.534-.137.802-.01.05-.02.041-.052.026l-.814-.39c-.255-.123-.514-.237-.765-.368-.304-.158-.634-.266-.892-.51-.241-.227-.505-.429-.76-.642l-.685-.579c-.288-.241-.574-.483-.862-.722-.12-.1-.23-.217-.375-.284-.3-.142-.61-.25-.947-.257a8.275 8.275 0 0 0-.512 0c-.186.007-.372.012-.556.046-.222.042-.412.133-.533.335a2.052 2.052 0 0 0-.182.405l-.622 1.811-.639 1.856c-.118.346-.236.692-.358 1.037-.074.21-.091.426-.068.643.023.208.09.41.193.595.075.134.167.256.273.37.078.082.177.137.257.216.145.14.273.295.41.444l.441.48c.136.148.273.295.408.445.139.152.276.305.418.454.124.13.24.267.366.395.092.092.176.194.267.289a.263.263 0 0 1 .083.202c-.003 1.22-.002 2.44-.001 3.66 0 .054 0 .107.006.161.011.107.055.203.091.308H7.834c-.046 0-.092-.002-.138 0-.04.002-.053-.001-.036-.047.063-.179.12-.36.18-.539l.425-1.285c.306-.926.613-1.85.921-2.774.022-.062.033-.108-.024-.154-.034-.027-.058-.064-.086-.098l-.65-.752-.383-.446c-.14-.161-.282-.321-.422-.483-.006.006-.008.007-.009.007l-1.961 5.843c-.053.155-.098.309-.09.476.004.084.035.165.029.252-.383 0-.766-.003-1.149 0-.482.005-.964-.018-1.446.014-.154.01-.307.041-.44.119a.623.623 0 0 0-.324.526.973.973 0 0 0 .142.574.744.744 0 0 0 .344.315c.158.062.332.076.499.109.185.037.371.069.558.101.18.032.362.064.543.092.207.03.412.064.62.089.261.03.521.074.782.105.235.028.472.048.707.07.238.024.476.047.713.068.221.019.441.033.661.055.106.01.212.019.318.025.13.008.26.018.389.022.025.007.051-.003.075.009l.16.004c.025.008.051-.002.075.009l.16.005c.026.007.052-.002.077.009l.187.004c.029.01.06-.002.09.01l.187.004c.029.008.06-.002.09.01l.228.004c.034.01.07-.004.104.01l.228.004c.048.01.097-.006.145.008l.27.006c.044.01.09-.006.133.009l.352.004c.058.01.116-.005.174.01l.477.004c.099.011.2-.007.298.01.018-.002.036-.006.055-.006l1.512.006.704-.001c.098-.015.198.002.296-.009l.48-.004c.055-.015.114 0 .17-.01.119 0 .237-.003.355-.004.048-.015.097 0 .144-.01l.27-.004c.043-.014.088 0 .132-.01l.228-.004c.033-.013.07 0 .104-.009l.228-.004c.029-.012.06-.002.09-.01l.188-.004c.03-.012.06 0 .089-.009l.188-.005c.025-.012.05-.002.076-.009l.16-.005c.029-.012.06 0 .089-.009.122-.004.245-.024.367-.019.024-.01.051 0 .076-.008a6.81 6.81 0 0 1 .134-.005c.024-.012.05 0 .073-.01.085-.006.17-.01.253-.018l.78-.067c.187-.015.373-.026.559-.045.278-.028.556-.061.834-.093.159-.019.318-.037.477-.06.24-.033.483-.069.725-.105.215-.031.433-.062.648-.1.286-.05.57-.115.858-.158a.677.677 0 0 0 .547-.415 1 1 0 0 0 .077-.605",
    fill: "#1A202C"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPaddleboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-paddleboard.a26ee157.svg";
export { ForwardRef as ReactComponent };